export enum QrOrderApiEnum {
  PosConfigModule = 'rpo-m',
  SystemSetting = 'system-settings',
  QrSession = 'qr-session',
  Qr = 'qr',
  Session = 'session',
  Approvals = 'approvals',
  Pending = 'pending',
  Approve = 'approve',
  Reject = 'reject',
  Cart = 'cart',
  CartStatus = 'cart-status',
}
